import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { currentEmbeddedApp, postOpenPlans } from '@/lib/app-embed/readEmbeddedApp';

/** Opens the plans: the app's native Planos tab when embedded, else /plans. */
export function useOpenPlans(): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    if (currentEmbeddedApp() && postOpenPlans()) return;
    navigate('/plans');
  }, [navigate]);
}
